import styles from "./PlusIcon.module.css";

export default function PlusIcon() {
  return <button className={styles.main}>PLUS</button>;
}
